export default __webpack_public_path__ + "static/media/user.750cb968.png";